import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

// App.scss has asked for Montserrat since the first commit and nothing ever
// shipped it: no @font-face, no stylesheet link, `document.fonts` empty on a
// loaded page. It rendered correctly only on machines that happen to have
// Montserrat installed, and fell back to the platform's default sans-serif
// everywhere else, which is most visitors. These are self-hosted files, so the
// fix adds no third-party request.
//
// Four weights, matching what the stylesheets actually use: 400 body, 500 the
// design's Medium, 600 a few navigation and card labels, 700 the design's Bold.
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";

import App from "./App";
import { store } from "./store";
import { unconfiguredProviders } from "./lib/env";

// Say out loud what this build cannot do. A hidden sign-in button looks the
// same whether it was switched off on purpose or never configured, and that
// ambiguity is how a client ships for months missing a credential nobody
// noticed. Not fatal: the rest of the application is unaffected, and refusing
// to start over one absent button would be worse than the button being absent.
const degraded = unconfiguredProviders();
if (degraded.length > 0) {
    console.error(
        `Federated sign-in is degraded, so these buttons are hidden: ${degraded.join(
            "; "
        )}. Set the variables in the build environment and rebuild.`
    );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);
